import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";

function IdeaModal({ close }) {
  return (
    <div className="AddnewsupportTicket relative max-w-[73rem]">
      {" "}
      <button
        onClick={() => close(false)}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <p className=" text-[#77498F] text-[2rem] leading-[3.2rem] font-bold text-center">
        شرح ایده
      </p>
      <div className=" mt-[5.6rem]">
        <div className=" grid grid-cols-2 gap-x-0 gap-y-[2rem]">
          <p className=" text-black font-normal text-[1.8rem] leading-[3.2rem]">
            نام ایده پرداز:
          </p>
          <p className=" text-[#212121E5] font-normal text-[1.4rem] leading-[2.4rem]">
            علی رجبی
          </p>
          <p className=" text-black font-normal text-[1.8rem] leading-[3.2rem]">
            ایمیل:
          </p>
          <p className=" text-[#212121E5] font-normal text-[1.4rem] leading-[2.4rem]">
            Alirajabi@gmail.com
          </p>
          <p className=" text-black font-normal text-[1.8rem] leading-[3.2rem]">
            موضوع:
          </p>
          <p className=" text-[#212121E5] font-normal text-[1.4rem] leading-[2.4rem]">
            طراحی پلتفرم فروش تبلیغات
          </p>
        </div>
        <div className=" mt-[1.5rem]">
          <p className=" text-black  font-normal text-[1.8rem] leading-[3.2rem]">
            شرح ایده:
          </p>
          <p className=" text-[#212121E5]  font-normal text-[1.4rem] leading-[2.4rem]">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز،
            و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای
            زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و
            متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان
            رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد
            کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه
            راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل
            حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود
            طراحی اساسا مورد استفاده قرار گیرد.
          </p>
        </div>
      </div>
    </div>
  );
}

export default IdeaModal;
